import { languageTag } from '../i18n'

const cache = new Map<string, Intl.NumberFormat>()

/**
 * One decimal place, in the reader's language: `4,7` in Norwegian, `4.7` in
 * English.
 *
 * QA 19 Oct ISSUE-004 (WEB-009 on 13 Oct): the hero read "4,7 (73 reviews)" on
 * the English site. `formatNumber` in `@avexa/utils` is Norwegian-only by
 * design — it is shared with places that are always Norwegian — so the
 * website's three DECIMAL renders (the rating and the directory's rating
 * filter) format here instead. Whole-number counts are left to `formatNumber`:
 * with no decimal point and values well under a thousand, the two languages
 * print them identically.
 */
export const formatOneDecimal = (value: number, language: string): string => {
  if (!Number.isFinite(value)) return '—'
  const tag = languageTag(language)
  let format = cache.get(tag)
  if (format === undefined) {
    format = new Intl.NumberFormat(tag, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    cache.set(tag, format)
  }
  return format.format(value)
}
